import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";
import { Tree } from "antd";
import { NodeItem } from "./NodeItem";

export function RenderTreeData(
  data: CategoriaFinanceiraItem,
  parent?: CategoriaFinanceiraItem,
  actionInative: boolean = false
) {
  return (
    <Tree.TreeNode
      title={
        <NodeItem data={data} parent={parent} actionInative={actionInative} />
      }
      // key={`${data.breadcrumb}-${data.nome}`}
      key={data.id}
      data={{ ...data, key: data.id }}
      active={false}
      className={`${
        data.breadcrumb?.length === 1 || !parent ? "primeiro-nivel" : ""
      } ${data.readOnly ? "nao-arrastavel" : ""}`}
    >
      {data.items
        ? data.items.map((v) => RenderTreeData(v, data, actionInative))
        : null}
    </Tree.TreeNode>
  );
}
